import clsx from 'clsx';
import { AnnouncementStatus } from '@/app/enums/AnnouncementStatus';
import { type EnumType } from '@/app/models/EnumType';

type AnnouncementStatusBadgeProps = {
  status: EnumType<AnnouncementStatus>;
};

const BADGE_CLASS_BY_STATUS: Record<AnnouncementStatus, string> = {
  [AnnouncementStatus.DRAFT]: 'badge-light-secondary',
  [AnnouncementStatus.PUBLISHED]: 'badge-light-success',
  [AnnouncementStatus.CLOSED]: 'badge-light-dark',
};

const AnnouncementStatusBadge = ({ status }: AnnouncementStatusBadgeProps) => (
  <span className={clsx('badge', BADGE_CLASS_BY_STATUS[status.value])}>{status.description}</span>
);

export default AnnouncementStatusBadge;
